import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import Layout from "../components/Layout/Layout";
import { getAuth, updateProfile } from "firebase/auth";
import { db } from "../firebase.config";
import { FaEdit, FaArrowAltCircleRight} from "react-icons/fa";
import { MdDoneOutline } from "react-icons/md";
import { doc, updateDoc, collection, getDocs, query, where, orderBy, deleteDoc } from "firebase/firestore";
import ListingItems from '../components/Layout/ListingItems';

const Profile = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const [listings, setListings] = useState(null) 
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    const fetchUserListings = async()=>{
      const listingRef = collection(db,'listing')
      const q = query(listingRef,where('userRef','==',auth.currentUser.uid),orderBy('timestamp', 'desc'))
      const querySnap = await getDocs(q)
      let listings = []
      querySnap.forEach(doc=>{
        return listings.push({
          id:doc.id,
          data:doc.data()
        })
      })

      setListings(listings);
      setLoading(false);
    }

    fetchUserListings();
  },[auth.currentUser.uid])

  const [changeDetails, setChangeDetails] = useState(false);
  const [formData, setFormData] = useState({
    name: auth.currentUser.displayName,
    email: auth.currentUser.email,
  });
  const { name, email } = formData;

  const handleLogout = async  () => {
    auth.signOut();
    toast.success("Successful Logout");
    navigate("/");
  };

  const onChange = (e) => {
     setFormData(prevState => ({
        ...prevState,
        [e.target.id]:e.target.value,
     }))
  }

  const onSubmit = async() => {
    try{
        if(auth.currentUser.displayName !== name){
            await updateProfile(auth.currentUser,{
              displayName:name,
            })
            const userRef = doc(db, 'users', auth.currentUser.uid);
            await updateDoc(userRef,{name});
            toast.success("User Updated !");
        }
    }
    catch(error)
    {
        console.log("click");
        toast.error('Something went wrong ')
    }
  };

  const onDelete = async(listingId) =>{
    if(window.confirm('Are you Sure! Continue to Delete ?')){
      const docRef = doc(db, 'listing', listingId);
      await deleteDoc(docRef)
      const updatedListings = listings.filter(listing => listing.id !== listingId)
      setListings(updatedListings)
      toast.success('Listing deleted Successfully !')
    }
  }

  const onEdit = (listingId) => {
    navigate(`/editlisting/${listingId}`)
  }

  return (
    <Layout>
      <div className="w-100 container mt-4 d-flex justify-content-between">
        <h2>Profile Details</h2><br/>
        <button className="btn btn-danger" onClick={handleLogout}>
          Logout
        </button>
      </div>
      <div className="container mt-3 card" style={{ width: "60%" }}>
        <div className="card-header">
          <div className="d-flex justify-content-between">
            <p>User Personal Details</p>
            <span
              style={{ cursor: "pointer" }}
              onClick={() => {
                changeDetails && onSubmit();
                setChangeDetails((prevState) => !prevState);
              }}
            >
              {changeDetails ? (
                <MdDoneOutline color="green" />
              ) : (
                <FaEdit color="red" />
              )}
            </span>
          </div>
        </div>
        <div className="card-body">
          <form>
          <div className="mb-3">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                value={name}
                onChange={onChange}
                disabled={!changeDetails}
              /> 
            </div>

            <div className="mb-3">
              <label htmlFor="exampleInputEmail1" className="form-label">
                Email address
              </label>
              <input
                type="email"
                value={email}
                className="form-control"
                id="email"
                aria-describedby="emailHelp"
                onChange={onChange }
                disabled={!changeDetails}
              />   
            </div>
            
          </form>
          </div>
          </div>
          <div className="container mt-4 d-flex" style={{width:"80%"}}>
          <Link to="/create-listing">
          <FaArrowAltCircleRight color="primary"/> Sell or Rent Your Home
          </Link>
          </div>
          <div className="container">
                {listings && listings?.length>0 && (
                  <>
                  <h2 className="mt-4">Your Listings</h2>
                  <p>All the Listings Posted by You</p>
                  <div>
                    {listings.map(listing =>(
                      <ListingItems key={listing.id} listing={listing.data} id={listing.id} onDelete={()=>onDelete(listing.id)} onEdit={()=>onEdit(listing.id)} />
                    ))}
                  </div>
                  </>
                )}
          </div>
    </Layout>
  );
};

export default Profile;
